import React from "react";
import { FormRow, Column } from "components/common/html";
import { RadioBasic } from "./radio-basic";

/**
 * Deprecated, use material for new code
 * */
export const RadioYesNo: React.FC<any> = props => (

  <FormRow style={{ marginBottom: props.marginBottom || 1 }}>
    <Column width={8}>
      <p>{props.label}</p>
    </Column>
    <Column width={4}>
      <RadioBasic
        label="Yes"
        name={props.name}
        value={true}
        formData={props.formData}
        defaultChecked={props.formData[props.name] === true}
      />
      <RadioBasic
        label="No"
        name={props.name}
        value={false}
        formData={props.formData}
        defaultChecked={props.formData[props.name] === false}
      />
    </Column>
  </FormRow>
);

// no left column, just yes/no inputs
export const RadioYesNoSmall: React.FC<any> = props => (
  <div>
    <RadioBasic
      label="Yes"
      name={props.name}
      value={true}
      formData={props.formData}
      defaultChecked={props.formData[props.name] === true}
      style={{ margin: "0 6px 0 0" }}
      labelStyle={{ paddingLeft: 0 }}
    />
    <RadioBasic
      label="No"
      name={props.name}
      value={false}
      formData={props.formData}
      defaultChecked={props.formData[props.name] === false}
      style={{ margin: "0 6px 0 0" }}
      labelStyle={{ paddingLeft: 0 }}
    />
  </div>
);
